export default "__VITE_ASSET__cbcb724d__"